// @ts-nocheck
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: import.meta.env.VITE_APP_API_KEY,
  authDomain: import.meta.env.VITE_APP_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_APP_PROJECT_ID,
  storageBucket: import.meta.env.VITE_APP_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_APP_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_APP_ID,
  measurementId: import.meta.env.VITE_APP_MEASUREMENT_ID,
};

// Initialize Firebase — only when the env actually provides a config.
// Local dev has no VITE_APP_PROJECT_ID, and initializing without it made the
// SDK warn "Missing App configuration value: projectId" on every page load.
// Push/analytics simply stay off in that case (same effective behavior).
let analytics;
let messaging;

if (
  firebaseConfig.projectId &&
  typeof window !== "undefined" &&
  typeof navigator !== "undefined"
) {
  try {
    const app = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
    messaging = getMessaging(app);
  } catch (e) {
    console.warn("Firebase SDK not fully supported in this environment:", e);
  }
}

export { messaging };

export { firebaseConfig };